(function () {
  'use strict';

  if (window.FotoMasterLeadProtection) return;

  var CHALLENGE_ENDPOINT = 'https://command.fotomaster.com/shopify/lead_challenge.php';
  var CLIENT_VERSION = '1.0.0';

  function now() {
    return window.performance && typeof window.performance.now === 'function'
      ? window.performance.now()
      : Date.now();
  }

  function boundedNumber(value, maximum) {
    var number = Number(value);
    if (!Number.isFinite(number) || number < 0) return 0;
    return Math.min(Math.round(number), maximum);
  }

  function create(options) {
    options = options || {};

    var formId = String(options.formId || '');
    var formType = String(options.formType || '');
    var startedAt = now();
    var visibleStartedAt = document.visibilityState === 'visible' ? startedAt : null;
    var visibleMs = 0;
    var trustedInteractions = 0;
    var changedFields = Object.create(null);
    var challengeToken = '';
    var challengeStatus = 'pending';
    var form = null;
    var attached = false;

    function addVisibleTime() {
      if (visibleStartedAt === null) return;
      visibleMs += Math.max(0, now() - visibleStartedAt);
      visibleStartedAt = null;
    }

    function onVisibilityChange() {
      if (document.visibilityState === 'visible') {
        if (visibleStartedAt === null) visibleStartedAt = now();
      } else {
        addVisibleTime();
      }
    }

    function registerInteraction(event) {
      if (event && event.isTrusted) {
        trustedInteractions = Math.min(trustedInteractions + 1, 1000);
      }
    }

    function registerFieldChange(event) {
      if (!event || !event.isTrusted || !event.target) return;
      var fieldName = event.target.name || event.target.id || 'field';
      changedFields[String(fieldName).slice(0, 100)] = true;
    }

    function attach() {
      if (attached) return;
      form = options.formElement || document.querySelector('[data-fm-lead-form="' + formType + '"]');
      if (!form) return;

      attached = true;
      form.addEventListener('pointerdown', registerInteraction, true);
      form.addEventListener('touchstart', registerInteraction, true);
      form.addEventListener('keydown', registerInteraction, true);
      form.addEventListener('input', registerFieldChange, true);
      form.addEventListener('change', registerFieldChange, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
    }

    function requestChallenge() {
      if (!formId || !formType || typeof window.fetch !== 'function') {
        challengeStatus = 'unavailable';
        return;
      }

      var controller = typeof window.AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 3500);
      var url = CHALLENGE_ENDPOINT
        + '?form_type=' + encodeURIComponent(formType)
        + '&form_id=' + encodeURIComponent(formId);

      window.fetch(url, {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        cache: 'no-store',
        signal: controller ? controller.signal : undefined
      }).then(function (response) {
        if (!response.ok) throw new Error('Challenge request failed');
        return response.json();
      }).then(function (result) {
        if (!result || result.status !== 'success' || !result.token) {
          throw new Error('Challenge response was incomplete');
        }
        challengeToken = String(result.token);
        challengeStatus = 'ready';
      }).catch(function () {
        // A protection outage must never stop a real lead.
        challengeStatus = 'unavailable';
      }).finally(function () {
        window.clearTimeout(timeout);
      });
    }

    function buildEvidence(submitEvent) {
      attach();

      var totalVisibleMs = visibleMs;
      if (visibleStartedAt !== null) {
        totalVisibleMs += Math.max(0, now() - visibleStartedAt);
      }
      var trap = form ? form.querySelector('[data-fm-lead-trap]') : null;

      return {
        client_version: CLIENT_VERSION,
        form_type: formType,
        challenge_token: challengeToken,
        challenge_status: challengeStatus,
        honeypot: trap && typeof trap.value === 'string' ? trap.value.slice(0, 500) : '',
        elapsed_ms: boundedNumber(now() - startedAt, 86400000),
        visible_ms: boundedNumber(totalVisibleMs, 86400000),
        trusted_interactions: trustedInteractions,
        trusted_field_changes: Object.keys(changedFields).length,
        submit_trusted: Boolean(submitEvent && submitEvent.isTrusted)
      };
    }

    attach();
    if (!attached) window.setTimeout(attach, 0);
    requestChallenge();

    return {
      buildEvidence: buildEvidence
    };
  }

  window.FotoMasterLeadProtection = {
    create: create
  };
  document.dispatchEvent(new CustomEvent('fm:lead-protection-ready'));
})();
